import React from "react";
import { useStockStatisticModel } from "../stockStatisticModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel, { transOptions } from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useStockStatisticModel();
    const { warehouseList, shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "是否有库存",
            fieldName: "inventoryQuantityGT",
            allowClear: true,
            options: [{ label: "是", value: 0 }],
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "是否有占用",
            fieldName: "occupy",
            options: [{ label: "是", value: 0 }, { label: "否", value: null as any }],
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "配件编码",
            fieldName: "materialCode"
        },

        {
            type: SearchTypeEnum.Select,
            placeholder: "仓库",
            fieldName: "warehouseCode",
            options: transOptions(warehouseList),
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "货位",
            fieldName: "shelfCode"
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: "所属站点",
        //     fieldName: "shopId",
        //     options: allShopDs,
        //     disabled: shopType === 0 ? false : true
        // },
    ]
    const searchMoreFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "配件名称",
            fieldName: "materialName"
        },
    ]
    return (
        <YhPageHeader
            title="库存统计"
            size="small"

            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            // handleSearch={loadData}
            handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}